import { useTheme } from '@mui/material/styles';

import { useHasBrandEngineFeatureFlag } from 'reservations/account/hooks/featureFlags';
import { getSafeContrastText } from 'reservations/brand/helpers/getContrastText';

const useContrastTextColor = () => {
  const hasBrandEngineFeature = useHasBrandEngineFeatureFlag();

  const theme = useTheme();
  const backgroundColor = theme.palette.background.default;
  // istanbul ignore next
  const textColor = hasBrandEngineFeature
    ? getSafeContrastText(theme, backgroundColor)
    : theme.palette.soy.main;
  return textColor;
};

export default useContrastTextColor;
